module.exports = __webpack_public_path__ + "img/feature_buy_zh.5667b1e8.png";